import { createFileRoute } from '@tanstack/react-router'
import AdministrationUsers from 'Administration/containers/AdministrationUsersContainer'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard, adminClaims } from '../../-guard'

export const Route = createFileRoute('/administration/users/')({
    component: () => (
        <Guard claims={adminClaims}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="page" />}>
                <AdministrationUsers />
            </Suspense>
        </Guard>
    ),
})
